import { DiagramsTab } from 'components/DiagramsTab';
import { LayersTab } from 'components/LayersTab';
import { PieTab } from 'components/PieTab';
import { SearchTab } from 'components/SearchTab';
import { TableTab } from 'components/TablesTab';
import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined';
import GridOnOutlinedIcon from '@mui/icons-material/GridOnOutlined';
import LeaderboardOutlinedIcon from '@mui/icons-material/LeaderboardOutlined';
import PieChartIcon from '@mui/icons-material/PieChart';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';
import { getText } from 'services/languageService';

export const tabsData = [
  {
    tabIcon: <AccountTreeOutlinedIcon />,
    value: 0,
    label: 'layers',
    name: getText('LAYERS_TL'),
    tabComponent: <LayersTab />,
  },
  {
    tabIcon: <GridOnOutlinedIcon />,
    value: 1,
    label: 'table',
    name: getText('TABLES_TL'),
    tabComponent: <TableTab />,
  },
  {
    tabIcon: <PieChartIcon />,
    value: 2,
    label: 'pie',
    name: getText('PIE_TAB_TL'),
    tabComponent: <PieTab />,
  },
  {
    tabIcon: <LeaderboardOutlinedIcon />,
    value: 3,
    label: 'diagrams',
    name: getText('DIAGRAMS_TL'),
    tabComponent: <DiagramsTab />,
  },
  {
    tabIcon: <SearchRoundedIcon />,
    value: 4,
    label: 'search',
    name: getText('SEARCH_TL'),
    tabComponent: <SearchTab />,
  },
];
